import {
  AlertSuccessIcon,
  Button,
  ExternalLinkIcon,
  Heading,
  HintIcon,
  Inline,
  Paragraph,
  SnapshotIcon,
  Stack,
} from 'canoe';
import React, { useEffect, useState } from 'react';

import { useExtensionInstallationState } from 'dashboard/containers/ExtensionStateProvider';

interface ExtensionPromptProps {
  onClose: VoidFunction;
  onSubmit: VoidFunction;
}

export const NewSnapshotModalExtensionPrompt = ({ onClose, onSubmit }: ExtensionPromptProps) => {
  const [stepIndex, setStepIndex] = useState(0);
  const { hasInstalledChromeExtension } = useExtensionInstallationState();

  useEffect(() => {
    if (hasInstalledChromeExtension) {
      setStepIndex(1);
    }
  }, [hasInstalledChromeExtension]);

  return (
    <>
      {stepIndex === 0 && (
        <>
          <Heading size="S" align="center" mt="normal" mb="normal">
            Please install the Candu Chrome Extension
          </Heading>
          <Inline space="s" wrap="nowrap">
            <HintIcon color="OnyxGrayL30" />
            <div>
              <Paragraph size="short" color="OnyxGrayL10" mb="s" maxWidth="none">
                The Candu Chrome Extension lets you create and edit content while viewing your
                website.
              </Paragraph>
              <Paragraph size="short" color="OnyxGrayL10" maxWidth="none">
                It will not make any changes to your website until you decide to publish those
                changes.
              </Paragraph>
            </div>
          </Inline>
          <Stack justify="center" space="xs">
            <Button
              variant="secondary"
              onClick={() =>
                window.open(
                  'https://chrome.google.com/webstore/detail/candu-for-chrome-launch-p/gpnmpnhiimfmafenhcojmfaejljffhpn',
                  '_blank',
                )
              }
            >
              <Inline space="xs" align="center">
                Install Chrome Extension
                <ExternalLinkIcon color="White" />
              </Inline>
            </Button>
            <Button variant="primary" appearance="text" onClick={onClose}>
              Cancel (not recommended)
            </Button>
          </Stack>
        </>
      )}

      {stepIndex === 1 && (
        <>
          <Stack justify="center" space="xs" spaceAfter="normal">
            <AlertSuccessIcon color="Success" size="xxl" mt="xs" />
            <Heading element="h2" size="S" align="center" mt="none" mb="none">
              The Candu Chrome Extension is installed!
            </Heading>
          </Stack>
          <Paragraph size="short" color="OnyxGrayL10" mb="s" maxWidth="none">
            We’ll now open your product in a new tab to grab a snapshot of it. This lets you preview
            your product in the Candu Editor while you create new content.
          </Paragraph>
          <Stack justify="center">
            <Button variant="primary" icon={SnapshotIcon} onClick={onSubmit}>
              Grab snapshot of your product
            </Button>
          </Stack>
        </>
      )}
    </>
  );
};
